<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-tabs :show-arrows="false">
      <v-tab>Informações</v-tab>
      <v-tab v-if="entry.id">Itens em Estoque</v-tab>
      <v-tab>Estoque Inicial</v-tab>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="entry.name"
              v-bind="getObject('name')"
              label="Nome"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="entry.location"
              v-bind="getObject('location')"
              label="Localização"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- itens em estoque -->
      <v-tab-item v-if="entry.id ? true : false">
        <v-row>
          <v-col cols="12" class="">
            <PurchaseItemIndex
              :purchaseItems="entry.purchaseItems"
              :readOnly="true"
              :purchaseTotalPrice.sync="purchaseItemsTotalPrice"
              objectType="StockItem"
              key="stocked_items"
              modelNameSingular="Item em Estoque"
              modelNamePlural="Itens em Estoque"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- estoque inicial -->
      <v-tab-item >
        <v-row>
          <v-col cols="12" class="">
            <PurchaseItemIndex 
              v-if="entry.canBeDeleted"
              :purchaseItems="entry.purchaseItemsAttributes"
              :readOnly="false"
              :initialStock="true"
              :purchaseTotalPrice.sync="initialPurchaseItemsTotalPrice"
              objectType="InitialStockItem"
              key="initial_stocked_items"
              modelNameSingular="Item de Estoque Inicial"
              modelNamePlural="Itens de Estoque Inicial"
            />
            <PurchaseItemIndex 
              v-else
              :purchaseItems="entry.purchaseItemsAttributes"
              :initialStock="true"
              :readOnly="true"
              :purchaseTotalPrice.sync="initialPurchaseItemsTotalPrice"
              objectType="InitialStockItem"
              key="initial_stocked_items"
              modelNameSingular="Item de Estoque Inicial"
              modelNamePlural="Itens de Estoque Inicial"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
// import PurchaseItemIndex from "@models/purchase_items/index.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      initialPurchaseItemsTotalPrice: 0,
      purchaseItemsTotalPrice: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    // PurchaseItemIndex: PurchaseItemIndex
  },
  beforeCreate: function () {
    this.$options.components.PurchaseItemIndex = require('@models/purchase_items/index.vue').default
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    console.log("entry", this.entry);

    // calcula o totalizador dos itens de estoque inicial
    this.initialPurchaseItemsTotalPrice = 0;
    for (var product in this.entry.purchaseItemsAttributes) {
      if (this.entry.purchaseItemsAttributes[product] && this.entry.purchaseItemsAttributes[product].totalPrice && !this.entry.purchaseItemsAttributes[product]._destroy) {
        this.initialPurchaseItemsTotalPrice += this.entry.purchaseItemsAttributes[product].totalPrice;
      }
    }
    this.initialPurchaseItemsTotalPrice = _.round(this.initialPurchaseItemsTotalPrice, 2);


    // calcula o totalizados dos itens de estoque
    this.purchaseItemsTotalPrice = 0;
    for (var product in this.entry.purchaseItems) {
      if (this.entry.purchaseItems[product] && this.entry.purchaseItems[product].totalPrice && !this.entry.purchaseItems[product]._destroy) {
        this.purchaseItemsTotalPrice += this.entry.purchaseItems[product].availableTotalPrice;
      }
    }
    this.purchaseItemsTotalPrice = _.round(this.purchaseItemsTotalPrice, 2);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
